package com.patronat.top.features.venues.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.VenueResponse
import com.patronat.top.features.venues.domain.repository.VenuesRepository
import com.patronat.top.features.venues.domain.usecase.command.GetVenueByIdCommand

class GetVenueByIdUseCase(
    private val venuesRepository: VenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetVenueByIdCommand, DomainResult<VenueResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetVenueByIdCommand): DomainResult<VenueResponse> {
        return venuesRepository.getVenueById(command.venueId)
    }
}
